import React, { Component } from 'react';

export default class FeedbackOptions extends Component {
  render() {
    const { label, onchange, isChecked, index, key } = this.props;

    return (
      <div className='d-flex input-group pt-20 pl-1'>
        <input
          ref={`input${index}`}
          type='radio'
          key={key}
          id={key}
          name={index}
          onChange={onchange}
          checked={isChecked}
          style={{ marginTop: '3px' }}
        />
        <label
          role='button'
          htmlFor={key}
          className='feedback-options-label'
          onClick={onchange}
          onKeyDown={() => {}}
        >
          {label}
        </label>
      </div>
    );
  }
}
